import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import {
  Grid,
  Icon,
  Form,
} from 'semantic-ui-react';
import DateTimePicker from '../../../components/DateTimePicker';

moment.locale('en-gb');

const inputDateFormat = 'DD/MM/YYYY, hh:mm A';

export default class SchedulePicker extends Component {
  static propTypes = {
    data: PropTypes.shape({
      scheduleStartAt: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.instanceOf(Date),
      ]),
      scheduleEndAt: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.instanceOf(Date),
      ]),
    }),
    onConfirm: PropTypes.func,
  }
  constructor(props) {
    super(props);
    const data = Object.assign({
      scheduleStartAt: null,
      scheduleEndAt: null,
    }, props.data || {});
    this.state = {
      data,
      visibleStart: false,
      visibleEnd: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    const data = Object.assign({
      scheduleStartAt: null,
      scheduleEndAt: null,
    }, nextProps.data || {});
    this.setState({
      data,
    });
  }
  handleOnVisible = (visibleID) => {
    const states = this.state;
    states.visibleStart = false;
    states.visibleEnd = false;
    states[visibleID] = true;
    this.setState(states);
  }
  handleOnHide = (visibleID) => {
    this.setState({ [visibleID]: false });
  }
  handleOnClear = (e, visibleID) => {
    const { data } = this.state;
    if (visibleID === 'scheduleStartAt') {
      data.scheduleStartAt = null;
    } else if (visibleID === 'scheduleEndAt') {
      data.scheduleEndAt = null;
    }
    this.setState({ data, [visibleID]: false }, () => {
      this.handleOnComfirm();
    });
  }
  handleOnChange = (value, id, visible) => {
    const { data } = this.state;
    let { visibleStart, visibleEnd } = this.state;
    if (id === 'scheduleStartAt') {
      visibleStart = visible;
    } else if (id === 'scheduleEndAt') {
      visibleEnd = visible;
    }
    data[id] = value || null;
    this.setState({ data, [id]: value, visibleStart, visibleEnd }, () => {
      this.handleOnComfirm();
    });
  }
  handleOnComfirm = () => {
    const { data } = this.state;
    if (this.props.onConfirm) {
      this.props.onConfirm(data);
    }
  }
  render() {
    const { data, visibleStart, visibleEnd } = this.state;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column mobile={16} tablet={8} computer={8}>
            <div className="ui form">
              <Form.Group widths="equal">
                <Form.Input
                  label="Schedule Start"
                  fluid
                  placeholder="Click to setup start date"
                  value={data.scheduleStartAt ? moment(data.scheduleStartAt).format(inputDateFormat) : ''}
                  readOnly
                  onFocus={() => this.handleOnVisible('visibleStart')}
                  icon={
                    data.scheduleStartAt ?
                      <Icon
                        color="red"
                        link
                        name="x"
                        onClick={e => this.handleOnClear(e, 'scheduleStartAt')}
                        title="Clear"
                      />
                      : 'calendar'
                  }
                />
              </Form.Group>
              <DateTimePicker
                closeableCompact={false}
                maxDate={data.scheduleEndAt && data.scheduleEndAt}
                noPadding
                onChange={(value, visible) => this.handleOnChange(value, 'scheduleStartAt', visible)}
                value={data.scheduleStartAt ? moment(data.scheduleStartAt).toDate() : ''}
                visible={visibleStart}
              />
            </div>
          </Grid.Column>

          <Grid.Column mobile={16} tablet={8} computer={8}>
            <div className="ui form">
              <Form.Group widths="equal">
                <Form.Input
                  label="Schedule End"
                  fluid
                  placeholder="Click to setup end date"
                  value={data.scheduleEndAt ? moment(data.scheduleEndAt).format(inputDateFormat) : ''}
                  readOnly
                  onFocus={() => this.handleOnVisible('visibleEnd')}
                  icon={
                    data.scheduleEndAt ?
                      <Icon
                        color="red"
                        link
                        name="x"
                        onClick={e => this.handleOnClear(e, 'scheduleEndAt')}
                        title="Clear"
                      />
                      : 'calendar'
                  }
                />
              </Form.Group>
              <DateTimePicker
                closeableCompact={false}
                minDate={data.scheduleStartAt && data.scheduleStartAt}
                onChange={(value, visible) => this.handleOnChange(value, 'scheduleEndAt', visible)}
                noPadding
                value={data.scheduleEndAt ? moment(data.scheduleEndAt).toDate() : ''}
                visible={visibleEnd}
              />
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sortable/SortablePackagePricing/SchedulePicker.jsx